import { CheckCircleOutlined, EditOutlined, EyeOutlined, StopOutlined } from "@ant-design/icons";
import { message, PageHeader, Popconfirm, Tag, Tooltip } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { ButtonItem, cuentaMask, SegmentedItem, TableItemDinamico } from "../../../Components/Items";
import moment from "moment";
import "moment/locale/es";
import AgregarFamiliaImplementacion from "./AgregarFamiliaImplementacion/AgregarFamiliaImplementacion";
import EditarFamiliaImplementacion from "./EditarFamiliaImplementacion/EditarFamiliaImplementacion";
import ImplementarFamiliaImplementacion from "./ImplementarFamiliaImplementacion/ImplementarFamiliaImplementacion";
import AgregarIndustria from "./AgregarIndustria/AgregarIndustria";
import FamiliasIndustria from "./FamiliasIndustria/FamiliasIndustria";
import AgregarInsumoImplementacion from "./AgregarInsumoImplementacion/AgregarInsumoImplementacion";
import FamiliasInsumoImplementacion from "./FamiliasInsumoImplementacion/FamiliasInsumoImplementacion";

moment.locale("es");

class FamiliasImplementacion extends Component {
    tableRef = null;
    tableIndustriasRef = null;
    tableInsumosRef = null;
    state = {
        todasFamiliasImplementacion: [],
        loading: false,
        valor: 1,
        initialValueContadores: null,
        initialValueUsuarios: null,
        initialValueFechaVencimiento: null,
        seccion: 1,
        todasIndustrias: [],
        totalRecordsIndustrias: 0,
        loadingIndustrias: false,
        vistaAgregarIndustria: false,
        industriaEditar: null,
        modalFamiliasIndustria: false,
        industriaFamilias: null,
        todosInsumos: [],
        totalRecordsInsumos: 0,
        loadingInsumos: false,
        modalAgregarInsumo: false,
        insumoEditarId: null,
        modalFamiliasInsumo: false,
        insumoFamilias: null,
    };
    consultarFamiliasImplementacion(params) {
        this.setState({ loading: true });
        axios
            .post(
                "familiasImplementacion/selectTodasFamiliasImplementacion",
                { ...params },
                {
                    headers: this.props.headersToken,
                }
            )
            .then((res) => {
                this.setState({ loading: false });
                if (res.data.success !== 2) {
                    this.setState({ todasFamiliasImplementacion: [] });
                } else {
                    this.setState({
                        todasFamiliasImplementacion: res.data.data,
                        totalRecords: res.data.totalRecords || 0,
                    });
                }
            });
    }

    abrirEditarFamiliaImplementacion(id) {
        this.setState({ modalEditarFamiliaImplementacion: true, modalEditarFamiliaImplementacionId: id });
    }
    cerrarEditarFamiliaImplementacion() {
        this.setState({ modalEditarFamiliaImplementacion: false });
        if (this.tableRef) {
            this.tableRef.updateExternalFilters({ valor: this.state.valor, textoFiltro: this.state.textoFiltro });
        }
    }

    abrirAgregarFamiliaImplementacion() {
        this.setState({ modalAgregarFamiliaImplementacion: true });
    }
    cerrarAgregarFamiliaImplementacion() {
        this.setState({ modalAgregarFamiliaImplementacion: false });
        if (this.tableRef) {
            this.tableRef.updateExternalFilters({ valor: this.state.valor, textoFiltro: this.state.textoFiltro });
        };
    }

    abrirImplementarFamiliaImplementacion() {
        this.setState({ modalImplementarFamiliaImplementacion: true });
    }
    cerrarImplementarFamiliaImplementacion() {
        this.setState({ modalImplementarFamiliaImplementacion: false });
        if (this.tableRef) {
            this.tableRef.updateExternalFilters({ valor: this.state.valor, textoFiltro: this.state.textoFiltro });
        }
    }

    deshabilitarFamiliaImplementacion(value) {
        axios
            .post(
                "familiasImplementacion/deshabilitarFamiliaImplementacion",
                { familiaId: value, empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    message.success("Familia deshabilitada");
                } else {
                    message.error("Sucedio un eror y no se pudo deshabilitar");
                }
                if (this.tableRef) {
                    this.tableRef.updateExternalFilters({ valor: this.state.valor, textoFiltro: this.state.textoFiltro });
                }
            });
    }
    habilitarFamiliaImplementacion(value) {
        axios
            .post(
                "familiasImplementacion/habilitarFamiliaImplementacion",
                { familiaId: value, empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    message.success("Familia habilitada");
                } else {
                    message.error("Sucedio un eror y no se pudo habilitar");
                }
                if (this.tableRef) {
                    this.tableRef.updateExternalFilters({ valor: this.state.valor, textoFiltro: this.state.textoFiltro });
                }
            });
    }
    consultarIndustrias(params) {
        this.setState({ loadingIndustrias: true });
        axios
            .post(
                "industrias/selectTodasIndustrias",
                { ...params },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                this.setState({ loadingIndustrias: false });
                if (res.data.success !== 2) {
                    this.setState({ todasIndustrias: [], totalRecordsIndustrias: 0 });
                } else {
                    this.setState({
                        todasIndustrias: res.data.data,
                        totalRecordsIndustrias: res.data.totalRecords || 0,
                    });
                }
            })
            .catch(() =>
                this.setState({
                    loadingIndustrias: false,
                    todasIndustrias: [],
                    totalRecordsIndustrias: 0,
                })
            );
    }

    recargarIndustrias() {
        if (this.tableIndustriasRef) {
            this.tableIndustriasRef.updateExternalFilters({ valor: this.state.valor });
        }
    }

    consultarInsumos(params) {
        this.setState({ loadingInsumos: true });
        axios
            .post(
                "insumosImplementacion/selectTodosInsumosImplementacion",
                { ...params },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                this.setState({ loadingInsumos: false });
                if (res.data.success !== 2) {
                    this.setState({ todosInsumos: [], totalRecordsInsumos: 0 });
                } else {
                    this.setState({
                        todosInsumos: res.data.data,
                        totalRecordsInsumos: res.data.totalRecords || 0,
                    });
                }
            })
            .catch(() =>
                this.setState({
                    loadingInsumos: false,
                    todosInsumos: [],
                    totalRecordsInsumos: 0,
                })
            );
    }

    recargarInsumos() {
        if (this.tableInsumosRef) {
            this.tableInsumosRef.updateExternalFilters({ valor: this.state.valor });
        }
    }

    // Solo para editar: al catálogo no se agrega nada desde aquí, un insumo
    // entra cuando se registra dentro de una familia.
    abrirAgregarInsumo(insumoId) {
        this.setState({ modalAgregarInsumo: true, insumoEditarId: insumoId || null });
    }
    cerrarAgregarInsumo(guardado) {
        this.setState({ modalAgregarInsumo: false, insumoEditarId: null });
        if (guardado) this.recargarInsumos();
    }

    abrirFamiliasInsumo(insumo) {
        this.setState({ modalFamiliasInsumo: true, insumoFamilias: insumo });
    }
    cerrarFamiliasInsumo() {
        this.setState({ modalFamiliasInsumo: false, insumoFamilias: null });
    }

    cambiarEstadoInsumo(insumoId, estado) {
        axios
            .post(
                estado === 1
                    ? "insumosImplementacion/habilitarInsumoImplementacion"
                    : "insumosImplementacion/deshabilitarInsumoImplementacion",
                { insumoImplementacionId: insumoId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    message.success(estado === 1 ? "Insumo habilitado" : "Insumo deshabilitado");
                } else {
                    message.error("Sucedio un eror y no se pudo cambiar el estado");
                }
                this.recargarInsumos();
            })
            .catch(() => message.error("Sucedio un eror y no se pudo cambiar el estado"));
    }

    // Al elegir una sección en el segmented siempre se cae en su tabla: si se
    // quedara abierta la vista de agregar/editar industria, picarle a "Industrias"
    // no llevaría al catálogo.
    cambiarSeccion(seccion) {
        this.setState({ seccion, vistaAgregarIndustria: false, industriaEditar: null });
    }

    abrirAgregarIndustria(industria) {
        this.setState({
            seccion: 2,
            vistaAgregarIndustria: true,
            industriaEditar: industria || null,
        });
    }
    // La vista guarda por su cuenta y avisa con guardado = true; al volver, la
    // tabla se remonta y pide de nuevo la página (y si ya estaba montada, se
    // recarga a mano).
    cerrarAgregarIndustria(guardado) {
        this.setState({ vistaAgregarIndustria: false, industriaEditar: null });
        if (guardado) this.recargarIndustrias();
    }

    abrirFamiliasIndustria(industria) {
        this.setState({ modalFamiliasIndustria: true, industriaFamilias: industria });
    }
    cerrarFamiliasIndustria() {
        this.setState({ modalFamiliasIndustria: false, industriaFamilias: null });
    }

    cambiarEstadoIndustria(industriaId, estado) {
        axios
            .post(
                estado === 1 ? "industrias/habilitarIndustria" : "industrias/deshabilitarIndustria",
                { industriaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    message.success(
                        estado === 1 ? "Industria habilitada" : "Industria deshabilitada"
                    );
                } else {
                    message.error("Sucedio un eror y no se pudo cambiar el estado");
                }
                this.recargarIndustrias();
            })
            .catch(() => message.error("Sucedio un eror y no se pudo cambiar el estado"));
    }

    render() {
        const columnasFamilias = [
            {
                title: "Número",
                dataIndex: "numero",
                key: "numero",
                width: "6%",
            },
            {
                title: "Nombre",
                dataIndex: "nombre",
                key: "nombre",
                buscar: "nombre",
                width: "25%",
            },
            {
                title: "Descripcion",
                dataIndex: "descripcion",
                key: "descripcion",
                buscar: "descripcion",
                width: "15%",
            },
            {
                title: "Tipo de Familia",
                dataIndex: "tipoDeFamilia",
                key: "tipoDeFamilia",
                buscar: "tipoDeFamilia",
                width: "15%",
            },
            {
                title: "Cuenta inv.",
                dataIndex: "cuentaInventario",
                key: "cuentaInventario",
                render: (value) => {
                    return <span>{value.cuenta ? cuentaMask(value.cuenta) : "Sin cuenta"}</span>;
                },
                width: "12%",
            },
            {
                title: "Cuenta costo gasto",
                dataIndex: "cuentaCostoGasto",
                key: "cuentaCostoGasto",
                render: (value) => {
                    return <span>{value.cuenta ? cuentaMask(value.cuenta) : "Sin cuenta"}</span>;
                },
                width: "12%",
            },
            {
                title: "Cuenta transito",
                dataIndex: "cuentaTransito",
                key: "cuentaTransito",
                render: (value) => {
                    return <span>{value.cuenta ? cuentaMask(value.cuenta) : "Sin cuenta"}</span>;
                },
                width: "12%",
            },
            {
                title: "Cuenta ajs.",
                dataIndex: "cuentaAjusteInventario",
                key: "cuentaAjusteInventario",
                render: (value) => {
                    return <span>{value.cuenta ? cuentaMask(value.cuenta) : "Sin cuenta"}</span>;
                },
                width: "12%",
            },
            {
                title: "Estado",
                dataIndex: "estado",
                key: "estado",
                width: "15%",
                render: (value) => {
                    if (value === 0) return <Tag color="red">Cancelado</Tag>;
                    if (value === 1) return <Tag color="green">Activo</Tag>;
                    if (value === 2) return <Tag color="orange">Deshabilitado</Tag>;
                    return <Tag color="blue">Desconocido</Tag>;
                },
            },
            {
                title: "Acción",
                dataIndex: "accion",
                key: "accion",
                width: "10%",
                align: "center",
                onHeaderCell: () => ({
                    style: { textAlign: 'center', padding: '4px' }
                }),
                onCell: () => ({
                    style: { textAlign: 'center', padding: '4px' }
                }),
                render: (value, record) => {
                    let buttons = [];

                    // Botón Editar
                    buttons.push(
                        <Tooltip title="Editar Familia" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                            <ButtonItem
                                type="default"
                                size="small"
                                cyan
                                icon={<EditOutlined />}
                                onClick={() => this.abrirEditarFamiliaImplementacion(record._id)}
                            >
                            </ButtonItem>
                        </Tooltip>
                    );

                    // Botón Habilitar/Deshabilitar
                    if (record.estado === 1) {
                        buttons.push(
                            <Popconfirm
                                title="Seguro que quieres deshabilitar esta familia"
                                onConfirm={() => this.deshabilitarFamiliaImplementacion(record._id)}
                                okText="Si"
                                cancelText="No"
                            >
                                <Tooltip title="Deshabilitar" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                                    <ButtonItem
                                        type="default"
                                        size="small"
                                        lima
                                        icon={<CheckCircleOutlined />}
                                    >
                                    </ButtonItem>
                                </Tooltip>
                            </Popconfirm>
                        );
                    } else {
                        buttons.push(
                            <Popconfirm
                                title="Seguro que quieres habilitar esta familia"
                                onConfirm={() => this.habilitarFamiliaImplementacion(record._id)}
                                okText="Si"
                                cancelText="No"
                            >
                                <Tooltip title="Habilitar" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                                    <ButtonItem
                                        type="default"
                                        size="small"
                                        rojo
                                        icon={<StopOutlined />}
                                    >
                                    </ButtonItem>
                                </Tooltip>
                            </Popconfirm>
                        );
                    }

                    return <div className="acciones-container">{buttons}</div>;
                },
            },
        ];

        const columnasIndustrias = [
            {
                title: "Número",
                dataIndex: "numero",
                key: "numero",
                width: "8%",
            },
            {
                title: "Nombre",
                dataIndex: "nombre",
                key: "nombre",
                buscar: "nombre",
                width: "22%",
            },
            {
                title: "Descripcion",
                dataIndex: "descripcion",
                key: "descripcion",
                buscar: "descripcion",
                width: "35%",
            },
            {
                title: "Familias",
                dataIndex: "familias",
                key: "familias",
                width: "12%",
                render: (value) => {
                    const total = value ? value.length : 0;
                    if (total === 0) return <Tag color="default">Sin familias</Tag>;
                    return <Tag color="cyan">{total === 1 ? "1 familia" : total + " familias"}</Tag>;
                },
            },
            {
                title: "Estado",
                dataIndex: "estado",
                key: "estado",
                width: "11%",
                render: (value) => {
                    if (value === 1) return <Tag color="green">Activo</Tag>;
                    if (value === 2) return <Tag color="orange">Deshabilitado</Tag>;
                    return <Tag color="blue">Desconocido</Tag>;
                },
            },
            {
                title: "Acción",
                dataIndex: "accion",
                key: "accion",
                width: "12%",
                align: "center",
                onHeaderCell: () => ({
                    style: { textAlign: 'center', padding: '4px' }
                }),
                onCell: () => ({
                    style: { textAlign: 'center', padding: '4px' }
                }),
                render: (value, record) => {
                    let buttons = [];

                    // Botón Editar
                    buttons.push(
                        <Tooltip key={"editar-" + record._id} title="Editar Industria" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                            <ButtonItem
                                type="default"
                                size="small"
                                cyan
                                icon={<EditOutlined />}
                                onClick={() => this.abrirAgregarIndustria(record)}
                            >
                            </ButtonItem>
                        </Tooltip>
                    );

                    // Botón Habilitar/Deshabilitar
                    if (record.estado === 1) {
                        buttons.push(
                            <Popconfirm
                                key={"deshabilitar-" + record._id}
                                title="Seguro que quieres deshabilitar esta industria"
                                onConfirm={() => this.cambiarEstadoIndustria(record._id, 2)}
                                okText="Si"
                                cancelText="No"
                            >
                                <Tooltip title="Deshabilitar" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                                    <ButtonItem
                                        type="default"
                                        size="small"
                                        lima
                                        icon={<CheckCircleOutlined />}
                                    >
                                    </ButtonItem>
                                </Tooltip>
                            </Popconfirm>
                        );
                    } else {
                        buttons.push(
                            <Popconfirm
                                key={"habilitar-" + record._id}
                                title="Seguro que quieres habilitar esta industria"
                                onConfirm={() => this.cambiarEstadoIndustria(record._id, 1)}
                                okText="Si"
                                cancelText="No"
                            >
                                <Tooltip title="Habilitar" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                                    <ButtonItem
                                        type="default"
                                        size="small"
                                        rojo
                                        icon={<StopOutlined />}
                                    >
                                    </ButtonItem>
                                </Tooltip>
                            </Popconfirm>
                        );
                    }

                    // Botón Ver industria: sus familias asignadas (hasta la derecha del renglón)
                    buttons.push(
                        <Tooltip key={"ver-" + record._id} title="Ver industria" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                            <ButtonItem
                                type="default"
                                size="small"
                                azul
                                icon={<EyeOutlined />}
                                onClick={() => this.abrirFamiliasIndustria(record)}
                            >
                            </ButtonItem>
                        </Tooltip>
                    );

                    return <div className="acciones-container">{buttons}</div>;
                },
            },
        ];

        const columnasInsumos = [
            {
                title: "Número",
                dataIndex: "numero",
                key: "numero",
                width: "8%",
            },
            {
                title: "Clave",
                dataIndex: "clave",
                key: "clave",
                buscar: "clave",
                width: "12%",
                render: (value) => value || "-",
            },
            {
                title: "Descripcion",
                dataIndex: "descripcion",
                key: "descripcion",
                buscar: "descripcion",
                width: "28%",
            },
            {
                title: "Unidad",
                dataIndex: "unidad",
                key: "unidad",
                width: "10%",
                render: (value) => value || "-",
            },
            {
                title: "Costo",
                dataIndex: "costo",
                key: "costo",
                width: "9%",
                render: (value) => (value || value === 0 ? value : "-"),
            },
            {
                title: "Familias",
                dataIndex: "familiaImplementacionIds",
                key: "familiaImplementacionIds",
                width: "12%",
                render: (value) => {
                    const total = value ? value.length : 0;
                    if (total === 0) return <Tag color="default">Sin familias</Tag>;
                    return <Tag color="cyan">{total === 1 ? "1 familia" : total + " familias"}</Tag>;
                },
            },
            {
                title: "Estado",
                dataIndex: "estado",
                key: "estado",
                width: "10%",
                render: (value) => {
                    if (value === 1) return <Tag color="green">Activo</Tag>;
                    if (value === 2) return <Tag color="orange">Deshabilitado</Tag>;
                    return <Tag color="blue">Desconocido</Tag>;
                },
            },
            {
                title: "Acción",
                dataIndex: "accion",
                key: "accion",
                width: "11%",
                align: "center",
                onHeaderCell: () => ({
                    style: { textAlign: 'center', padding: '4px' }
                }),
                onCell: () => ({
                    style: { textAlign: 'center', padding: '4px' }
                }),
                render: (value, record) => {
                    let buttons = [];

                    buttons.push(
                        <Tooltip key={"editar-" + record._id} title="Editar Insumo" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                            <ButtonItem
                                type="default"
                                size="small"
                                cyan
                                icon={<EditOutlined />}
                                onClick={() => this.abrirAgregarInsumo(record._id)}
                            >
                            </ButtonItem>
                        </Tooltip>
                    );

                    if (record.estado === 1) {
                        buttons.push(
                            <Popconfirm
                                key={"deshabilitar-" + record._id}
                                title="Seguro que quieres deshabilitar este insumo"
                                onConfirm={() => this.cambiarEstadoInsumo(record._id, 2)}
                                okText="Si"
                                cancelText="No"
                            >
                                <Tooltip title="Deshabilitar" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                                    <ButtonItem
                                        type="default"
                                        size="small"
                                        lima
                                        icon={<CheckCircleOutlined />}
                                    >
                                    </ButtonItem>
                                </Tooltip>
                            </Popconfirm>
                        );
                    } else {
                        buttons.push(
                            <Popconfirm
                                key={"habilitar-" + record._id}
                                title="Seguro que quieres habilitar este insumo"
                                onConfirm={() => this.cambiarEstadoInsumo(record._id, 1)}
                                okText="Si"
                                cancelText="No"
                            >
                                <Tooltip title="Habilitar" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                                    <ButtonItem
                                        type="default"
                                        size="small"
                                        rojo
                                        icon={<StopOutlined />}
                                    >
                                    </ButtonItem>
                                </Tooltip>
                            </Popconfirm>
                        );
                    }

                    buttons.push(
                        <Tooltip key={"ver-" + record._id} title="Ver familias" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                            <ButtonItem
                                type="default"
                                size="small"
                                azul
                                icon={<EyeOutlined />}
                                onClick={() => this.abrirFamiliasInsumo(record)}
                            >
                            </ButtonItem>
                        </Tooltip>
                    );

                    return <div className="acciones-container">{buttons}</div>;
                },
            },
        ];

        const tituloSeccion =
            this.state.seccion === 2
                ? "Industrias"
                : this.state.seccion === 3
                ? "Insumos Implementación"
                : "Familias Implementación";

        return (
            <>
                <PageHeader
                    title={tituloSeccion}
                    style={{
                        border: "1px solid rgb(235, 237, 240)",
                        backgroundColor: "white",
                        marginBottom: 10,
                    }}
                    extra={
                        <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                            {window.innerWidth > 1000 &&
                                <>
                                    <SegmentedItem
                                        options={[{ label: 'Activas', value: 1 }, { label: "Deshabilitadas", value: 2 }, { label: 'Todos', value: 3 }]}
                                        onChange={(value) => {
                                            if (this.tableRef) {
                                                this.tableRef.updateExternalFilters({ valor: value, textoFiltro: this.state.textoFiltro });
                                            }
                                            if (this.tableIndustriasRef) {
                                                this.tableIndustriasRef.updateExternalFilters({ valor: value });
                                            }
                                            if (this.tableInsumosRef) {
                                                this.tableInsumosRef.updateExternalFilters({ valor: value });
                                            }
                                            this.setState({ valor: value });
                                        }}
                                        value={this.state.valor}
                                    />
                                    <div className="header-divider"></div>
                                </>
                            }
                            <SegmentedItem
                                options={[{ label: 'Familias', value: 1 }, { label: "Industrias", value: 2 }, { label: "Insumos", value: 3 }]}
                                onChange={(value) => this.cambiarSeccion(value)}
                                value={this.state.seccion}
                            />
                            <div className="header-divider"></div>
                            <ButtonItem
                                type="primary"
                                key="implementarFamiliaImplementacion"
                                verde
                                className="botonAgregar"
                                onClick={this.abrirImplementarFamiliaImplementacion.bind(this)}
                            >
                                Implementar
                            </ButtonItem>
                            <ButtonItem
                                type="primary"
                                key="agregarFamiliaImplementacion"
                                olivo
                                className="botonAgregar"
                                onClick={this.abrirAgregarFamiliaImplementacion.bind(this)}
                            >
                                Agregar Familia
                            </ButtonItem>
                            <ButtonItem
                                type="primary"
                                key="agregarIndustria"
                                className="botonAgregar"
                                onClick={() => this.abrirAgregarIndustria()}
                            >
                                Agregar Industria
                            </ButtonItem>
                        </div>
                    }
                />
 
                <div style={{ display: this.state.seccion === 1 ? "block" : "none" }}>
                    <TableItemDinamico
                        ref={(ref) => this.tableRef = ref}
                        onRef={(ref) => this.tableRef = ref}
                        totalRecords={this.state.totalRecords}
                        loading={this.state.loading}
                        onFetchData={this.consultarFamiliasImplementacion.bind(this)}
                        anadirValorFiltro={this.state.valor}
                        size="small"
                        onlyMineFilter
                        dataSource={this.state.todasFamiliasImplementacion}
                        columns={columnasFamilias}
                        scroll={{ x: "max-content" }}
                        filterStorageKey={"familiasImplementacion"}
                        setValor={(valor) => {
                            if (valor === this.state.valor) return;
                            this.setState({ valor }, () => {
                                this.recargarIndustrias();
                                this.recargarInsumos();
                            });
                        }}
                        valorDefault={1}
                    />
                </div>
                <div style={{ display: this.state.seccion === 2 ? "block" : "none" }}>
                    {this.state.vistaAgregarIndustria ? (
                        // Agregar / editar industria reemplaza a la tabla aquí mismo. El key
                        // hace que se remonte al pasar de editar una industria a otra (o a
                        // una nueva), para que los initialValues se vuelvan a aplicar.
                        <AgregarIndustria
                            key={this.state.industriaEditar ? this.state.industriaEditar._id : "nueva"}
                            industria={this.state.industriaEditar}
                            cerrarAgregarIndustria={this.cerrarAgregarIndustria.bind(this)}
                        />
                    ) : (

                        <TableItemDinamico
                            ref={(ref) => this.tableIndustriasRef = ref}
                            onRef={(ref) => this.tableIndustriasRef = ref}
                            totalRecords={this.state.totalRecordsIndustrias}
                            loading={this.state.loadingIndustrias}
                            onFetchData={this.consultarIndustrias.bind(this)}
                            anadirValorFiltro={this.state.valor}
                            size="small"
                            dataSource={this.state.todasIndustrias}
                            columns={columnasIndustrias}
                            scroll={{ x: "max-content" }}
                            onRow={(record) => ({
                                onDoubleClick: () => this.abrirFamiliasIndustria(record),
                            })}
                        />
                    )}
                </div>
                <div style={{ display: this.state.seccion === 3 ? "block" : "none" }}>
                    <TableItemDinamico
                        ref={(ref) => this.tableInsumosRef = ref}
                        onRef={(ref) => this.tableInsumosRef = ref}
                        totalRecords={this.state.totalRecordsInsumos}
                        loading={this.state.loadingInsumos}
                        onFetchData={this.consultarInsumos.bind(this)}
                        anadirValorFiltro={this.state.valor}
                        size="small"
                        dataSource={this.state.todosInsumos}
                        columns={columnasInsumos}
                        scroll={{ x: "max-content" }}
                        onRow={(record) => ({
                            onDoubleClick: () => this.abrirFamiliasInsumo(record),
                        })}
                    />
                </div>
                <AgregarInsumoImplementacion
                    key={this.state.insumoEditarId || "nuevo"}
                    visible={this.state.modalAgregarInsumo}
                    insumoId={this.state.insumoEditarId}
                    cerrarAgregarInsumoImplementacion={this.cerrarAgregarInsumo.bind(this)}
                />
                <FamiliasInsumoImplementacion
                    visible={this.state.modalFamiliasInsumo}
                    insumo={this.state.insumoFamilias}
                    cerrarFamiliasInsumoImplementacion={this.cerrarFamiliasInsumo.bind(this)}
                />
                <AgregarFamiliaImplementacion
                    visible={this.state.modalAgregarFamiliaImplementacion}
                    cerrarAgregarFamiliaImplementacion={this.cerrarAgregarFamiliaImplementacion.bind(this)}
                />
                <EditarFamiliaImplementacion
                    visible={this.state.modalEditarFamiliaImplementacion}
                    cerrarEditarFamiliaImplementacion={this.cerrarEditarFamiliaImplementacion.bind(this)}
                    familiaId={this.state.modalEditarFamiliaImplementacionId}
                />
                <ImplementarFamiliaImplementacion
                    visible={this.state.modalImplementarFamiliaImplementacion}
                    cerrarImplementarFamiliaImplementacion={this.cerrarImplementarFamiliaImplementacion.bind(this)}
                />
                <FamiliasIndustria
                    visible={this.state.modalFamiliasIndustria}
                    industria={this.state.industriaFamilias}
                    cerrarFamiliasIndustria={this.cerrarFamiliasIndustria.bind(this)}
                />
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
    };
};

export default connect(mapStateToProps)(FamiliasImplementacion);
